import * as approvals from "./approvalsActions";
import * as billingActions from "./billingActions";
import * as cdd from "./cddActions";
import * as checkoutConfiguration from "./checkoutConfigurationActions";

export interface State {
    [cdd.namespace]: cdd.CustomerDueDiligenceState;
    [approvals.namespace]: approvals.ApprovalsState;
    [checkoutConfiguration.namespace]: checkoutConfiguration.CheckoutConfigurationState;
    [billingActions.namespace]: billingActions.State;
}

export const initialState: State = {
    [cdd.namespace]: cdd.initialState,
    [approvals.namespace]: approvals.initialState,
    [checkoutConfiguration.namespace]: checkoutConfiguration.initialState,
    [billingActions.namespace]: billingActions.initialState,
};

export const reducers = {
    [cdd.namespace]: cdd.reducer,
    [approvals.namespace]: approvals.reducer,
    [checkoutConfiguration.namespace]: checkoutConfiguration.reducer,
    [billingActions.namespace]: billingActions.reducer,
};
